import {
  BorderBox,
  Box,
  Divider,
  FlexBox,
  Text,
  TextSmall,
} from '@trmediaab/zebra';

import { useImmutableState } from '../../state';
import Layout from '../Layout';
import type { ZeroToHundred } from './Range';

interface LabelProps {
  label: string;
  active: boolean;
  textAlign?: 'left' | 'center' | 'right';
}

const Label = ({ label, active, textAlign }: LabelProps) => (
  <TextSmall
    fontWeight="semiBold"
    color={active ? 'checkout.progressTextActive' : 'checkout.progressText'}
    width="100%"
    textAlign={textAlign}
  >
    {label}
  </TextSmall>
);

interface NumProps {
  num: '1' | '2' | '3';
  active: boolean;
}

const Num = ({ num, active }: NumProps) => (
  <BorderBox
    borderRadius="circle"
    bg={active ? 'checkout.progressNumBgActive' : 'checkout.progressNumBg'}
    width="19px"
    height="19px"
  >
    <Text
      fontWeight="semiBold"
      color={active ? 'checkout.progressNumActive' : 'checkout.progressNum'}
      fontSize="0"
      width="100%"
      textAlign="center"
      pt="1px"
    >
      {num}
    </Text>
  </BorderBox>
);

interface ProgressBarProps {
  progress: ZeroToHundred;
}

const ProgressBar = ({ progress }: ProgressBarProps) => {
  const { appMode, hasProductOptions } = useImmutableState();

  return appMode === 'redeemGift' ? null : (
    <Layout.progressArea
      sx={{
        visibility: hasProductOptions === 'pending' ? 'hidden' : 'visible',
      }}
    >
      <Box maxWidth="550px" mx="auto">
        <FlexBox mb="2">
          {hasProductOptions && (
            <FlexBox width="25%">
              <Label label="Ditt val" textAlign="left" active />
            </FlexBox>
          )}
          <FlexBox width="50%">
            <Label
              label="Dina uppgifter"
              textAlign={!hasProductOptions ? 'left' : 'center'}
              active={progress >= 50}
            />
          </FlexBox>
          <FlexBox width={!hasProductOptions ? '50%' : '25%'}>
            <Label
              label="Betalning"
              textAlign="right"
              active={progress >= 75}
            />
          </FlexBox>
        </FlexBox>
        <FlexBox alignItems="center">
          <Num num="1" active />
          <Box flex="1" height="3px" bg="checkout.progressNumBg">
            <Divider
              height="100%"
              bg="checkout.progressNumBgActive"
              width={`${progress >= 50 ? '100' : (progress * 2).toString()}%`}
            />
          </Box>
          {hasProductOptions && <Num num="2" active={progress >= 50} />}
          <Box flex="1" height="3px" bg="checkout.progressNumBg">
            <Divider
              height="100%"
              bg="checkout.progressNumBgActive"
              width={`${
                progress <= 50 ? 0 : ((progress - 50) * 2).toString()
              }%`}
            />
          </Box>
          <Num num={!hasProductOptions ? '2' : '3'} active={progress >= 75} />
        </FlexBox>
      </Box>
    </Layout.progressArea>
  );
};

export default ProgressBar;
